export default __webpack_public_path__ + "static/media/SOCKET-DOUBLE-OWON.03b88991.png";